export default {
  242: 'fulltime',
  243: 'parttime',
  244: 'contracttemp',
  245: 'casualvacation',
};
